import { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import "./ProfileDropdown.css";
import UserCircle from "../../assets/icons/UserCircle.svg";
import Exp7 from "../../assets/icons/Exp-7.-S.svg";
import ArrowDown from "../../assets/icons/Group 33921.svg";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import LogoutNotif from "../../components/logoutnotif_v2/LogoutNotif";
import ApiService from "../../components/Api_services";
import FallbackImg from "../FallbackImg";
import { ACCESS_KEYS, REDIRECT_SWITCH_USER_URL } from "../../constants";
import { hasAccess } from "../../utils/Permission";
import { useContext } from "react";
import { TotalAmountContext } from "../../contexts/TotalAmountContext";
import { LogIn, FileText, LogOut } from "lucide-react";

const ProfileDropdown = ({ open, fetchCounts }) => {
  const { user } = useSelector((state) => state.auth);
  const [showLogout, setShowLogout] = useState(false);
  // const [totalOverdue, setTotalOverdue] = useState(0);
  const { overdueTotal } = useContext(TotalAmountContext);
  const [totalCredit, setTotalCredit] = useState("");
  const totalCreditFetched = useRef(false);
  // const myOrderTotalUnread = useSelector(state => state.order.myOrderTotalUnread);
  // const myInvoiceTotalUnread = useSelector(state => state.invoice.myInvoiceTotalUnread);
  const orderCount = useSelector((state) => state.unread.orderTotalUnread);
  const invoiceCount = useSelector((state) => state.unread.invoiceTotalUnread);
  const paymentCount = useSelector((state) => state.unread.paymentTotalUnread);
  const debitCount = useSelector((state) => state.unread.debitTotalUnread);
  const [resubmitCount, setResubmitCount] = useState(0);
  const profileOptionRef = useRef(null);
  const [atTop, setAtTop] = useState(true);
  const [atBottom, setAtBottom] = useState(false);

  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const sub_role = useSelector((state) => state.auth.sub_role) || [];
  const is_subuser =
    useSelector((state) => state.auth.user?.is_subuser) || false;

  const hasCredit = user?.has_term === true;
  const hasRefund = user?.has_cbd === true;

  const canViewProfile =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_PROFILE);
  const canViewOrder = !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_ORDER);
  const canViewRepair =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_REPAIR);
  const canViewInvoice =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_INVOICE);
  const canViewPayment =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_PAYMENT);
  const canViewCredit = !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_CN);
  const canViewDebit = !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_DN);
  const canViewContra =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_CONTRA);
  const canViewRefund = !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_RF);
  const canViewDocument =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.DOCUMENT);

  const salesmanId = localStorage.getItem("salesman_id");
  const isSalesmanLogin = !!salesmanId;

  const [showSwitchUser, setShowSwitchUser] = useState(false);
  const [switchUsers, setSwitchUsers] = useState([]);
  const [selectedSwitchUser, setSelectedSwitchUser] = useState("");
  const [switchLoading, setSwitchLoading] = useState(false);
  const [switchError, setSwitchError] = useState("");

  // useEffect(() => {
  //   ApiService.getTotalAmount().then((res) => {
  //     if (res.status === 200 && res.data) {
  //       setTotalOverdue(res.data.total_overdue_amount || 0);
  //     }
  //   });
  // }, []);

  useEffect(() => {
    if (open) {
      ApiService.countResubmitReceipt().then((res) => {
        if (res.status === 200 && res.data.total) {
          setResubmitCount(res.data.total);
        } else {
          setResubmitCount(0);
        }
      });
      fetchCounts();
    }
  }, [open]);

  // useEffect(() => {
  //   if (open) {
  //     fetchCounts();
  //   }
  // }, [open, fetchCounts]);

  const fetchTotalCredit = async () => {
    try {
      const response = await ApiService.getCreditTransactionHistory({
        page: 1,
        limit: 1,
        status_filter: "all",
      });

      // if (response && response.status === 200 && response.data) {
      //   setTotalCredit(response.data.total_cn_amt || "899.80");
      //   totalCreditFetched.current = true;
      // }
      if (response && response.status === 200 && response.data) {
        setTotalCredit(response.data.total_cn_amt);
        totalCreditFetched.current = true;
      }
    } catch (err) {
      console.error("Failed to fetch total credit:", err);
    }
  };

  useEffect(() => {
    if (!totalCreditFetched.current) {
      fetchTotalCredit();
    }
  }, []);

  // Scroll handler
  const handleScroll = () => {
    const el = profileOptionRef.current;
    if (!el) return;
    setAtTop(el.scrollTop === 0);
    setAtBottom(el.scrollTop + el.clientHeight >= el.scrollHeight - 1);
  };

  useEffect(() => {
    const el = profileOptionRef.current;
    if (!el) return;
    el.addEventListener("scroll", handleScroll);
    // Set initial state
    handleScroll();
    return () => el.removeEventListener("scroll", handleScroll);
  }, [open]);

  const openSwitchUser = async () => {
    setShowSwitchUser(true);
    setSwitchError("");
    setSelectedSwitchUser("");
    if (switchUsers.length === 0) {
      try {
        const currentCustomerId = localStorage.getItem("customer_id") || "";
        const res = await ApiService.getSwitchUsers(
          salesmanId,
          currentCustomerId,
        );
        const raw =
          (res && res.data && res.data.users) || (res && res.data) || res || [];
        const arr = Array.isArray(raw) ? raw : [];
        const normalized = arr
          .map((u) => {
            const id = (u.customerid ?? u.customer_id ?? u.id ?? "") + "";
            const name = u.name ?? u.company_name ?? u.company ?? id;
            return id ? { id, name } : null;
          })
          .filter(Boolean);
        setSwitchUsers(normalized);
      } catch (err) {
        console.error("Failed to load switchable users", err);
        setSwitchError("Failed to load users");
      }
    }
  };

  const handleConfirmSwitch = async () => {
    if (!selectedSwitchUser) {
      setSwitchError("Please select a user");
      return;
    }
    setSwitchLoading(true);
    try {
      const makeTimestamp = () => {
        const d = new Date();
        const pad = (n) => n.toString().padStart(2, "0");
        return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
      };
      const payload = `salesman_login,${selectedSwitchUser},${salesmanId},${makeTimestamp()}`;
      const pid = btoa(payload);

      // set global flag to prevent session-expired popup while switching
      window.__skipSessionNotice = true;

      // call login API to obtain token and user data (no redirect race)
      const res = await ApiService.login({ pid });

      // clear flag
      window.__skipSessionNotice = false;

      const token =
        res?.access_token ||
        res?.data?.access_token ||
        res?.new_token ||
        res?.data?.new_token;
      if (token) {
        localStorage.setItem("access_token", token);
        localStorage.setItem("company_name", res.data.company_name || "");
        localStorage.setItem("salesman_id", res.data.salesman_id);
        localStorage.setItem("customer_id", res.data.customer_id || "");
        localStorage.setItem("real_company_name", res.data.real_name || "");
        // optionally update redux user if res contains user info
        window.location.replace("/");
      } else {
        setSwitchError(res?.message || "Switch failed");
      }
    } catch (err) {
      window.__skipSessionNotice = false;
      console.error("Switch error", err);
      setSwitchError("Switch failed");
    } finally {
      setSwitchLoading(false);
    }
  };

  // useEffect(() => {
  //   console.log("sub_role value:", sub_role);
  // }, [sub_role]);

  if (!user) {
    return <div className="profiledropdown-loading_v2">Loading...</div>;
  }

  return (
    <div className="profiledropdown_v2">
      {open && <div className="custom-dropdown-overlay_v2" />}
      <div className={`profiledropdown-content_v2 ${open ? "show" : ""}`}>
        <div className="profileoption_v2" ref={profileOptionRef}>
          <div
            style={{
              opacity: canViewOrder ? 1 : 0.5,
              cursor: canViewOrder ? "pointer" : "not-allowed",
            }}
            title={canViewOrder ? "" : "No permission"}
          >
            {canViewOrder ? (
              <Link to="/allorder">
                <div
                  className="pd-order-container_v2"
                  style={{ width: "100%" }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 10 }}
                  >
                    <FileText size={16} />
                    <div className="pd-order_v2">My Orders</div>
                  </div>
                  {orderCount > 0 && (
                    <div className="unread-tag_v2">{orderCount}</div>
                  )}
                </div>
              </Link>
            ) : (
              <div className="pd-order-container_v2">
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <FileText size={16} />
                  <div className="pd-order_v2">My Order</div>
                </div>
                {orderCount > 0 && (
                  <div className="unread-tag_v2">{orderCount}</div>
                )}
              </div>
            )}
          </div>

          <div
            className="logout-container_v2"
            onClick={() => setShowLogout(true)}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <LogOut size={16} />
              <div className="logout_v2">Logout</div>
            </div>
          </div>
        </div>
      </div>
      {showLogout && <LogoutNotif onClose={() => setShowLogout(false)} />}
    </div>
  );
};

export default ProfileDropdown;
